import {
  GET_AGILE_PURCHASE_BY_SECTOR,
  GET_AGILE_PURCHASE_BY_SECTOR_ERROR,
  GET_AGILE_PURCHASE_BY_SECTOR_SUCCESS
} from './AgilePurchaseBySector.actions'

const initialState = {
  data: [],
  csv: [],
  csvAccumulated: [],
  enhancedData: [],
  loading: false,
  error: null
}
/**
 * Agile Purchase By Sector's reducer.
 */
const agilePurchaseBySectorReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_AGILE_PURCHASE_BY_SECTOR:
      return { ...state, loading: true }
    case GET_AGILE_PURCHASE_BY_SECTOR_SUCCESS:
      return {
        ...state,
        csv: payload.csv,
        csvAccumulated: payload.csvAccumulated,
        data: payload.data,
        enhancedData: payload.enhancedData,
        loading: false
      }
    case GET_AGILE_PURCHASE_BY_SECTOR_ERROR:
      return {
        ...state,
        error: payload.error,
        loading: false,
        data: [],
        csv: [],
        csvAccumulated: [],
        enhancedData: []
      }
    default:
      return state
  }
}

export default agilePurchaseBySectorReducer
